import axios from 'axios'
import Utils from '@/common/Utils'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = { 'Content-Type': 'application/json' }

export default class UserNotificationService {
    static async notifyOnCompanyUpdate (request) {
        return new Promise(async (resolve, reject) => {
            try {
                headers['Authorization'] = await Utils.setLocalToken()
                let data = await axios.post(url + '/notifyOnCompanyUpdate/', request, { headers })
                resolve(data)
            } catch (error) {
                reject(error)
            }
        })
    }
}
